var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"right","mode":"out-in"}},[_c('keep-alive',[_c(_vm.compName,_vm._b({tag:"component"},'component',_vm.editProps,false,true))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }